// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"editor_layoutWrapper__OuYXX","main":"editor_main__ZFmyC","sidebar":"editor_sidebar__059tG"};